import { createContext } from 'react';

import { Context } from '../../../types';
import { PaymentTermsOption } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

export default createContext<Context<PaymentTermsOption>>(getContextDefaultValues(api));
